import { Component, OnInit, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subscription, combineLatest } from "rxjs";
import { map } from "rxjs/operators";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { ApiService } from "src/app/services/api/api.service";
import { Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app";
import { ModalService } from "src/app/modules/modal/services/modal.service";
import {
  selectIsAuthenticating,
  selectIsAuthenticated,
  selectAuthenticatedUserMe,
  selectManageOwnAuctions,
  selectAuthenticatedAdmin,
} from "src/app/store/selectors";
import { MeRequest } from "src/app/store/actions/user";

@Component({
  selector: "app-withdraw-balance",
  templateUrl: "./withdraw-balance.component.html",
  styleUrls: ["./withdraw-balance.component.scss"],
})
export class WithdrawBalanceComponent implements OnInit, OnDestroy {
  private selectIsAuthenticated: boolean;
  private selectIsAuthenticatedSubscription: Subscription;
  private userPhoneNumber;
  private modalStep;
  private transactionSuccess = true; // temporary

  private balanceForm: FormGroup;

  private balanceModalSubscription: Subscription;
  private modalSubject = new BehaviorSubject(1);
  private timer: number;
  private timerInterval;
  private userInformation;
  private balanceTypeValue;
  private phoneCodeChangeSubscription: Subscription;

  private balanceWithdrawSubscription: Subscription;

  constructor(
    private apiService: ApiService,
    private _store: Store<IAppState>,
    private formBuidler: FormBuilder,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.selectIsAuthenticatedSubscription = combineLatest(
      this._store.select(selectIsAuthenticating),
      this._store.select(selectIsAuthenticated),
      this._store.select(selectAuthenticatedUserMe),
      this._store.select(selectManageOwnAuctions),
    ).subscribe(([authenticating, authenticated, user]) => {
      this.selectIsAuthenticated = authenticated;
      if (!authenticating && authenticated) {
        if (user) {
          this.userInformation = user;
          this.userPhoneNumber = user.phone_number;
        }
      }
    });

    this.balanceForm = this.formBuidler.group({
      price: new FormControl(null),
      phone_code: new FormControl(null),
    });

    this.balanceModalSubscription = this.modalSubject.subscribe(
      (item: number) => {
        this.modalStep = item;
        if (item === 2) {
          this.sendSms();
        } else {
          this.resetPhoneCodeValue();
        }
      },
    );
  }

  closeModal() {
    this.modalService.closePopup();
  }

  resetTimer() {
    this.timer = 60;
  }

  runMinuteCountdown(process): void {
    if (this.timer > 0 && process) {
      clearInterval(this.timerInterval);
      this.timer--;
      this.timerInterval = setInterval(() => {
        this.runMinuteCountdown(true);
      }, 1000);
    } else {
      clearInterval(this.timerInterval);
    }
  }

  verifySmsCode() {
    this.apiService
      .post("validate/phone", {
        phone_number: this.userInformation.phone_number,
        country_id: this.userInformation.country_id,
        sms_code: this.form.get("phone_code").value,
      })
      .pipe(map((response: any) => response))
      .subscribe((response) => {
        this.resetPhoneCodeValue();
        if (response.result) {
          this.balanceTransaction();
        }
      });
  }

  resetPhoneCodeValue(): void {
    this.form.get("phone_code").reset();
  }

  sendSms() {
    this.resetTimer();
    this.runMinuteCountdown(true);
    // send sms
    // get result
    this.phoneCodeChangeSubscription = this.form
      .get("phone_code")
      .valueChanges.subscribe((item) => {
        if (item && item.length === 4) {
          this.verifySmsCode();
        }
      });
  }

  balanceTransaction() {
    // send request

    // this.transactionSuccess = response.result;
    this.modalSubject.next(3);
  }

  modalFirstStep() {
    this.modalSubject.next(1);
  }

  modalSecondStep() {
    // this.modalSubject.next(2);
    this.modalSubject.next(3); // temporary
    this.withdrawMoney();
  }

  modalThirdStep() {
    this.modalSubject.next(3);
  }

  withdrawMoney() {
    this.balanceWithdrawSubscription = this.apiService
      .post("payments/refund", {
        amount: this.withdrawAmount,
      })
      .pipe(map((response: any) => response))
      .subscribe((response) => {
        this.modalStep = 3;
        this._store.dispatch(new MeRequest({}));
      });
  }

  get getBalanceTypeValue() {
    return this.balanceTypeValue;
  }

  get form() {
    return this.balanceForm;
  }

  get getTransactionSuccess() {
    return this.transactionSuccess;
  }

  get getModalStep() {
    return this.modalStep;
  }

  get getUserPhoneNumber() {
    return this.userPhoneNumber;
  }

  get getTimer() {
    return this.timer;
  }

  get withdrawAmount() {
    return Number(this.balanceForm.get("price").value);
  }

  get user() {
    return this.userInformation;
  }

  get disableWithdrawButton() {
    return (
      !this.withdrawAmount ||
      this.withdrawAmount === 0 ||
      this.withdrawAmount > Number(this.user.balance)
    );
  }

  ngOnDestroy() {
    this.selectIsAuthenticatedSubscription.unsubscribe();

    if (this.phoneCodeChangeSubscription) {
      this.phoneCodeChangeSubscription.unsubscribe();
    }

    if (this.balanceModalSubscription) {
      this.balanceModalSubscription.unsubscribe();
    }

    if (this.balanceWithdrawSubscription) {
      this.balanceWithdrawSubscription.unsubscribe();
    }
  }
}
